import { Box, Typography } from '@mui/material';

import { FHConfirmDialog, FHInputField } from '../../../../../components/base';
import { useSubmitCohortPasswordModal } from './hooks';

interface SubmitCohortPasswordModalProps {
  open: boolean;
  onClose: () => void;
  onPasswordVerified: () => void;
}

function SubmitCohortPasswordModal({
  open,
  onClose,
  onPasswordVerified,
}: SubmitCohortPasswordModalProps) {
  const { password, handlePasswordChange, handleConfirmSubmit, isSubmitDisabled } =
    useSubmitCohortPasswordModal({
      open,
      onClose,
      onPasswordVerified,
    });

  return (
    <FHConfirmDialog
      open={open}
      onClose={onClose}
      title="Add cohort"
      dialogHeight={320}
      contentRenderer={() => (
        <Box sx={{ my: 2, width: '100%' }}>
          <Typography variant="body2" sx={{ mb: 1 }} textAlign="left">
            Password
          </Typography>
          <FHInputField
            fullWidth
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={handlePasswordChange}
            placeholder="Enter password"
            inputHeight={40}
          />
        </Box>
      )}
      canceltext="Cancel"
      submittext="Submit"
      onSubmit={handleConfirmSubmit}
      disableSubmitButton={isSubmitDisabled}
    />
  );
}

export default SubmitCohortPasswordModal;
